import { render, staticRenderFns } from "./IlpaNewReleaseBambu.vue?vue&type=template&id=b69de85a&scoped=true"
import script from "./IlpaNewReleaseBambu.vue?vue&type=script&lang=js"
export * from "./IlpaNewReleaseBambu.vue?vue&type=script&lang=js"
import style0 from "./IlpaNewReleaseBambu.vue?vue&type=style&index=0&id=b69de85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69de85a",
  null
  
)

export default component.exports